<app-login-page>
	@if (failed) {
		<div class="text-center">
			<span class="text-error">Cannot proceed with Login</span>
			<br />
			<a href="/login">Back to login</a>
		</div>
	} @else {
		<h1>Login in progress... Please wait...</h1>

		<p-progressbar
			mode="indeterminate"
			[style]="{ height: '6px' }"
		/>
	}
</app-login-page>
